/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import classnames from 'classnames';
import { Modal, Toast } from 'antd-mobile';
import './index.scss';
import logo2 from 'image/download/logo@2x.png';
import mask from 'image/download/mask.png';

import topBg from 'image/download/newLoad_top_bg1.png';
import topCircle1 from 'image/download/newLoad_circle4.png';
import topCircle2 from 'image/download/newLoad_circle5.png';
import topCircle3 from 'image/download/newLoad_circle6.png';

import eBg from 'image/download/newLoad_e_bg1.png';
import weekImg from 'image/download/newLoad_zhoubao1.png';
import coacherImg from 'image/download/newLoad_teacher.png';


import careerBg from 'image/download/newLoad_career_bg1.png';
import cepinImg from 'image/download/newLoad_cepin1.png';
import careerImg from 'image/download/newLoad_zhiyuan1.png';

import xinliBg from 'image/download/newLoad_xinli_bg1.png';
// import xinliCircleImg from 'image/download/newLoad_xinli_circle.png';
import bottomBg from 'image/download/newLoad_bottom_bg1.png';

// import androdWhiteImg from 'image/download/androd_white.png';
// import androdBlackImg from 'image/download/androd_black.png';
// import iosWhiteImg from 'image/download/ios_white.png';
// import iosBlackImg from 'image/download/ios_black.png';
import androdImg from 'image/download/android_new.png';
import iosImg from 'image/download/ios_new.png';
import { queryParse } from '~/utils/query';
import { getLatestFullVersion, getCustomDownloadUrl } from '~/api';
import { www } from '~/utils/hosts';

import CallApp from '~/lib/call-app';

function checkBrowser() {
  const u = navigator.userAgent,
    app = navigator.appVersion;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('HarmonyOS'); // android终端或者uc浏览器
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/ipad|mac\s?os?x?|macintosh/ig); // ios终端 || ipad
  const isWX = (/micromessenger/i).test(u);
  const isAlipay = (/AlipayClient/i).test(u);
  const QQBrowser = u.match(/qq/i) != null || u.match(/qqbrowse/i) != null || u.match(/qq/i) != null;
  const isIosQQ = (isiOS && / QQ/i.test(u));
  const isAndroidQQBrowser = (isAndroid && /MQQBrowser/i.test(u) && !(/QQ/i.test((u).split('MQQBrowser'))));
  const isDingTalk = (/dingtalk/i).test(u);
  const isHarmony = (/ArkWeb/i).test(u);
  return { app, isAndroid, isiOS, isWX, isAlipay, QQBrowser, isIosQQ, isAndroidQQBrowser, isDingTalk, isHarmony };
}

const {
  isiOS, isWX, isAlipay, QQBrowser,
  isAndroidQQBrowser, isDingTalk, isHarmony,
} = checkBrowser();
let { domain, action, params, letterId, letterIdWeb, qd } = queryParse(window.location.search);
let router = '';
try {
  params = JSON.parse(params);
  const routerObj = JSON.stringify({
    domain,
    action,
    params,
  });
  router = encodeURIComponent(`mistong://${routerObj}`);
  // eslint-disable-next-line no-empty
} catch (e) {
}
// 这里只是唤起app功能 如果没有app 则没反应
// 1:需要判断 如果安装的是校园版的包 打开下载页 是否还是会默认唤起  如果没有唤起 则fallback要动态配置
// 2: pc代码 download页面  二维码是否要替换
// 3: pc代码 SchoolAppLoad页面 二维码要重新确认 需要有更多入参  如：qd=xiaoyuan&domain=web&action=open_notopbar_webview&params=%7B"url":"http://web.ewt360.com/community/dogRecord/#/home","title":"年度报告","show_title_bar":"false","control_android_backkey":"false","allows_gestures_navigation":"false"%7D&letterId=maka@20210120%2526APP&letterIdWeb=maka@20210120%2526pc&channel=maka@20210120
const callLib = new CallApp({
  scheme: {
    protocol: 'ewt',
    host: 'www.ewt360.com',
  },
  intent: {
    scheme: 'ewt',
    package: 'com.mistong.ewt360',
  },
  appstore: 'https://itunes.apple.com/cn/app/id1027705496',
  fallback: '//app.ewt360.com/app.htm?t=zA3aIr',
});

class Download extends Component {
  state = {
    topAnimated: false,
    shakeAni: false,
    eScrolled: false,
    careerScrolled: false,
    label: '',
  };

  componentDidMount() {
    if (isHarmony) {
      Modal.alert('温馨提示', '鸿蒙设备请到应用商店下载升学e网通App哦～');
    } else {
      this.callApp();
    }

    const { label } = queryParse(window.location.search);
    this.setState({
      label,
    });
    setTimeout(() => {
      this.setState({ topAnimated: true }, () => {
        this.animationTopAction();
        // this.rotateAni();
      });
    }, 800);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop && scrollTop > 470 && scrollTop < 730) {
      const { eScrolled } = this.state;
      if (eScrolled) {
        return;
      }
      this.setState({ eScrolled: true }, () => {
        this.eSectionAnimation();
      });
    } else if (scrollTop && scrollTop > 870 && scrollTop < 1200) {
      const { careerScrolled } = this.state;
      if (careerScrolled) {
        return;
      }
      this.setState({ careerScrolled: true }, () => {
        this.careerSectionAnimation();
      });
    }
  }


  animationTopAction = () => {
    const aniView = document.getElementById('top1');
    aniView.classList.add('animate__animated', 'animate__bounceInDown');
    aniView.addEventListener('animationend', () => {
      aniView.classList.remove('animate__animated', 'animate__bounceInDown');
      setTimeout(() => {
        this.setState({ shakeAni: true });
      }, 40);
    });

    const aniView1 = document.getElementById('top2');
    aniView1.classList.add('animate__animated', 'animate__bounceInDown');
    aniView1.addEventListener('animationend', () => {
      aniView1.classList.remove('animate__animated', 'animate__bounceInDown');
    });


    const aniView3 = document.getElementById('top3');
    aniView3.classList.add('animate__animated', 'animate__bounceInDown');
    aniView3.addEventListener('animationend', () => {
      aniView3.classList.remove('animate__animated', 'animate__bounceInDown');
    });
  }


  eSectionAnimation = () => {
    const aniView = document.getElementById('e1');
    aniView.classList.add('animate__animated', 'animate__bounceInLeft');
    aniView.addEventListener('animationend', () => {
      aniView.classList.remove('animate__animated', 'animate__bounceInLeft');
    });

    const aniView1 = document.getElementById('e2');
    aniView1.classList.add('animate__animated', 'animate__bounceInRight');
    aniView1.addEventListener('animationend', () => {
      aniView1.classList.remove('animate__animated', 'animate__bounceInRight');
    });
  }

  careerSectionAnimation = () => {
    const aniView = document.getElementById('career1');
    aniView.classList.add('animate__animated', 'animate__bounceInLeft');
    aniView.addEventListener('animationend', () => {
      aniView.classList.remove('animate__animated', 'animate__bounceInLeft');
    });

    const aniView1 = document.getElementById('career2');
    aniView1.classList.add('animate__animated', 'animate__bounceInRight');
    aniView1.addEventListener('animationend', () => {
      aniView1.classList.remove('animate__animated', 'animate__bounceInRight');
    });
  }

  downAction = () => {
    if (isiOS && !!qd) {
      Toast.info('暂无iOS版本，请使用电脑下载', 3);
      return;
    }
    if (!isiOS) {
      const { label } = this.state;
      // 主动触达灰度标签
      if (label) {
        getCustomDownloadUrl({
          data: { label },
        }).then((res) => {
          window.location.href = res.data.downloadUrl;
        });
        return;
      }
      getLatestFullVersion({
        data: { channelId: qd ? 2 : 1 },
      }).then((res) => {
        window.location.href = res.data[0].downloadUrl;
      });
      return;
    }
    // 如果ios系统的。直接到应用商店去
    window.location.href = 'https://itunes.apple.com/us/app/sheng-xuee-wang-tong/id1027705496?l=zh&ls=1&mt=8';
  }


  // rotateAni = () => {
  //   setInterval(() => {
  //     const roteView = document.getElementById('xinliRote');
  //     roRateVal += 5;
  //     roteView.style.transform = `rotate(${roRateVal}deg)`;
  //     // 设置旋转时的动画  匀速0.1s
  //     roteView.style.transition = '0.1s linear';
  //   }, 100);
  // }


  callApp = () => {
    if (isWX || isAlipay || (QQBrowser && !isAndroidQQBrowser)) return;
    if (isiOS && !!qd) {
      Toast.info('暂无iOS版本，请使用电脑下载', 3);
      return;
    }
    callLib.open({
      path: '',
      param: {
        router,
        letterId,
      },
      callback: () => {
        console.log('error');
      },
    });
  };

  render() {
    // const downloadIconClass = isAndroid ? 'phoneIco android' : 'phoneIco ios';
    const { topAnimated, eScrolled, careerScrolled, shakeAni, label } = this.state;
    const leftCls = classnames('leftAni', { aniShow: topAnimated }, { aniMation: shakeAni });
    const rightCls = classnames('rightAni', { aniShow: topAnimated }, { aniMation: shakeAni });
    const bottomCls = classnames('bottomAni', { aniShow: topAnimated }, { aniMation: shakeAni });

    return (
      (isWX || isAlipay || (QQBrowser && !isAndroidQQBrowser) || isDingTalk) ? (
        <div className="wrap">
          <div className="mask-wrap">
            <div className="mask">
              <img className="mask-img" src={mask} alt="请用浏览器打开" />
            </div>
          </div>
        </div>
      ) : (
        <div className="wrap">
          <a onClick={this.callApp} className="fixed-bar">
            <img src={logo2} className="top-logo" alt="ewt360" />
            <div className="top-content">
              <h3>升学e网通</h3>
              <p>升学助考一网通</p>
            </div>

            {
              !isHarmony && (
                <div className="top_btn_warp" onClick={() => this.downAction()}>
                  <div className="top-btn">立即下载</div>
                </div>
              )
            }
          </a>
          <div className="topSection">
            <div className="topText1">升学e网通APP</div>
            {
              label === 'gray-weekend' ? <div className="topText2">（扫码下载 - 周培优业务）</div> : null
            }
            <div className="topText2">用互联网改变教育，让中国人都有好书读</div>
            <div className="topText3">升学e网通提供在线名师辅导、心态调节、心灵成长、</div>
            <div className="topText3"> 升学报考、生涯规划等一站式解决方案，帮助高中生 </div>
            <div className="topText3">实现一站式教学服务。</div>
            <div className="downMenuWrapper">
              {!isHarmony && (
                <div className="downMenu" onClick={() => this.downAction()}>
                  {isiOS && <img src={iosImg} alt="" />}
                  {isiOS && <div className="menueText">&nbsp;APP下载</div>}
                  {!isiOS && <img src={androdImg} alt="" />}
                  {!isiOS && <div className="menueText">&nbsp;android下载</div>}
                </div>
              )}
            </div>
            <div className="pcLink">
              <a href={`${www}/site-www/home/page?from=appDownloadPage`}>访问网页版</a>
            </div>
          </div>
          <div className="topSectionBg" id="top" style={{ backgroundImage: `url("${topBg}")` }}>
            <div className={leftCls} id="top1" style={{ backgroundImage: `url("${topCircle1}")` }} />
            <div className={bottomCls} id="top2" style={{ backgroundImage: `url("${topCircle2}")` }} />
            <div className={rightCls} id="top3" style={{ backgroundImage: `url("${topCircle3}")` }} />
          </div>
          <div className="itemMenu">
            <div className="itemTitle">E讲堂</div>
            <div className="itemText">海量精品课程、优质习题，还有学情报告和错题本<br />
              高中三年九大学科全覆盖，满足个性化需求<br />
            </div>
          </div>
          <div className="eSectionBg" style={{ backgroundImage: `url("${eBg}")` }}>
            <div className={eScrolled ? 'weekAni aniShow' : 'weekAni'} id="e2" style={{ backgroundImage: `url("${weekImg}")` }} />
            <div className={eScrolled ? 'coachAni aniShow' : 'coachAni'} id="e1" style={{ backgroundImage: `url("${coacherImg}")` }} />
          </div>
          <div className="itemMenu">
            <div className="itemTitle">生涯规划</div>
            <div className="itemText">从生涯唤醒到认识自我，从新高考选科到志愿填<br />科学树立升学目标，规划你的高中三年</div>
          </div>
          <div className="careerSectionBg" style={{ backgroundImage: `url("${careerBg}")` }}>
            <div className={careerScrolled ? 'testAni aniShow' : 'testAni'} id="career1" style={{ backgroundImage: `url("${cepinImg}")` }} />
            <div className={careerScrolled ? 'careerAni aniShow' : 'careerAni'} id="career2" style={{ backgroundImage: `url("${careerImg}")` }} />
          </div>
          <div className="itemMenu">
            <div className="itemTitle">心灵成长</div>
            <div className="itemText">
              针对高中生的成长电台和心事互动平台<br />
              用温柔诉说解决你的疑惑，陪伴健康成长
            </div>
          </div>
          <div className="xinliSectionBg" style={{ backgroundImage: `url("${xinliBg}")` }}>
            {/* <div className="xinliAni" id="xinliRote" style={{ backgroundImage: `url("${xinliCircleImg}")` }} /> */}
          </div>
          <img style={{ width: '100vw' }} src={bottomBg} alt="" />
          <div className="bottomSecton">
            <div className="bottomText">这么好的学习工具，你还在等什么？<br />课堂无界，快去感受知识的美好吧！</div>
            <div className="downMenuWrapper">
              {!isHarmony && (
                <div className="downMenu lightScene" onClick={() => this.downAction()}>
                  {isiOS && <img src={iosImg} alt="" />}
                  {isiOS && <div className="menueText lightScene">&nbsp;APP下载</div>}
                  {!isiOS && <img src={androdImg} alt="" />}
                  {!isiOS && <div className="menueText lightScene">&nbsp;android下载</div>}
                </div>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}
export default Download;



// WEBPACK FOOTER //
// ./src/components/pages/download/index.jsx